import absoluteURL from './absoluteURL'
export default absoluteURL